import React, { useState, useEffect, useContext } from "react";
import { Context } from "../../index";
import {Card} from "react-bootstrap";

const API_URL = "https://script.google.com/macros/s/AKfycbxT4gfyPAgrG1R5skYYGBMuHYSSxALb6qoR0Pu3q1l8YP4vj5PxTa1XxExFsEOcmMGY/exec";

const UserWishlist = () => {
    const [wishlist, setWishlist] = useState([]);
    const [title, setTitle] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const { user } = useContext(Context);

    const fetchWishlist = async () => {
        if (!user?.user?.id) {
           setError("User ID is missing. Please log in.");
            return;
        }

        const url = `${API_URL}?userId=${user.user.id}`;

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                },
            });


            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const text = await response.text(); // 📌 Получаем просто текст (не парсим сразу JSON)

           const data = JSON.parse(text); // Теперь пробуем парсить JSON
            console.log("Received data:", data);

            setWishlist(data);
        } catch (err) {
           setError("Failed to load wishlist. Please try again.");
        }
    };



    const submitWishlist = async (e) => {
        e.preventDefault();

       if (!title.trim() || !user?.user?.id || !user?.user?.username || !user?.user?.email) {
            setError("Invalid input data.");
            return;
        }

        setLoading(true);
        setError("");

        try {
            const response = await fetch(API_URL, {
                method: "POST",
                mode: "no-cors", // 🔥 Отключаем CORS
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    userId: String(user.user.id), // 🔥 Преобразуем в строку
                    name: user.user.username,
                    email: user.user.email,
                    title: title.trim()
                }),
               });

           setTitle("");
            setTimeout(fetchWishlist, 2000);
        } catch (err) {
            console.error("Error submitting wishlist:", err);
            setError("Failed to submit your request. Please try again.");
        } finally {
            setLoading(false);
        }
    };


    // 🔥 Автообновление списка каждые 10 секунд
    useEffect(() => {
        fetchWishlist();
        const interval = setInterval(fetchWishlist, 60000);
        return () => clearInterval(interval);
    }, [user]);

    return (
        <Card className="p-3 w-100 mt-2">
        <div className="container mb-2 mt-2">
            <h5 className="text-muted mb-3">Your Wishlist</h5>
            <p className="text-muted mb-4 small">
                We’re <strong>dedicated</strong> to <em>constantly improving</em> our service and <strong>rolling out new features</strong>.
                If you have any <em>ideas</em> or <strong>suggestions</strong>, please <strong>share them with us</strong>—your feedback helps us make <em>Virtalibry</em> even better.
            </p>

            {/* Форма для добавления пожелания */}
            <form onSubmit={submitWishlist} className="mb-4">
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your idea..."
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                    <button className="btn btn-success" type="submit" disabled={loading}>
                        {loading ? "Submitting..." : "Submit"}
                    </button>
                </div>
            </form>

            {/* Ошибка загрузки */}
            {error && <div className="alert alert-danger">{error}</div>}

            {/* Отображение списка пожеланий */}
            <div className="list-group">
                {wishlist.length > 0 ? (
                    wishlist.map((item, index) => (
                        <div key={index} className="list-group-item d-flex justify-content-between align-items-center small">
                            <div>
                                <strong>{item.title}</strong> <br />
                                <small className="text-muted">
                                    Created: {new Date(item.date).toLocaleDateString("en-US")}
                                </small>
                            </div>
                            <span className={`badge ${item.status === "Pending" ? "bg-warning" : "bg-success"}`}>
                                {item.status}
                            </span>
                        </div>
                    ))
                ) : (
                    <p className="text-muted">No wishes yet. Be the first to add one!</p>
                )}
            </div>
          </div>
        </Card>
    );
};

export default UserWishlist;
